/* eslint-disable react/forbid-prop-types */
import React from 'react';
import './styles.scss';
import PropTypes from 'prop-types';

const EpFormInputIcon = ({
  labelText, inputIcon, placeholderText,
  inputType, inputName, onChange, inputId, classError, onBlur, value, onFocus, disabled,

}) => (
  <>
    <label htmlFor={inputName} className="form-label">{labelText}</label>
    <div className={`input-group ${classError || ''} form`}>
      <label className={`input-group-text ${disabled ? 'form__label-icon--disabled' : 'form__label-icon'}`} htmlFor="icon2"> {inputIcon}</label>
      <input disabled={disabled} onFocus={onFocus} value={value} onBlur={val => onBlur(val)} autoComplete="off" id={inputId} onChange={val => onChange(val)} type={inputType} className="form-control form__input-with-icon" placeholder={placeholderText} name={inputName} />
    </div>
  </>
);
export default EpFormInputIcon;

EpFormInputIcon.defaultProps = {
  placeholderText: null,
  disabled: false,
  onFocus: null,
};

EpFormInputIcon.propTypes = {
  placeholderText: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  inputIcon: PropTypes.element.isRequired,
  inputType: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classError: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onFocus: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
};
